import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Component from "./component";
import withOtp from "../../shared/with-otp";
import { saveCustomerReview } from "./actions";
import { fetchData } from "../lead-models/actions";

const mapStateToProps = ({
    user: { isLoggedIn, secureToken, name },
    config: { cityList: cities },
    brands: { all: carMakeList },
    models
}) => ({
    isLoggedIn,
    secureToken,
    name,
    cities,
    carMakeList,
    models
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    saveCustomerReviewConnect: saveCustomerReview,
    fetchModelsBasedOnMakeConnect: fetchData
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withOtp(Component)));
